export default __webpack_public_path__ + "a8ca6cea68820134b55c6602302ac50e.png";